import { Alert, Column, Typography } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { responsive } from '@/utils';

import { StyledGuide, StyledStepList } from './presetGuide/presetGuide.styles.ts';

/** How-to for presets and preset groups, shown in its own tab of the preset modal. */
export const PresetGuide = () => {
  const { t } = useTranslation('cameraControl');

  return (
    <StyledGuide>
      <Column gap={responsive.spacing.small}>
        <Typography type={'heading_medium'}>{t('preset.guide.presetTitle')}</Typography>
        <Typography type={'body_medium'}>{t('preset.guide.presetIntro')}</Typography>
        <Typography type={'body_medium'} weight={'bold'}>
          {t('preset.guide.levelDefinition')}
        </Typography>
        <StyledStepList>
          {presetStepKeys.map(key => (
            <li key={key}>
              <Typography type={'body_medium'}>{t(key)}</Typography>
            </li>
          ))}
        </StyledStepList>
      </Column>
      <Column gap={responsive.spacing.small}>
        <Typography type={'heading_medium'}>{t('preset.guide.groupTitle')}</Typography>
        <Typography type={'body_medium'}>{t('preset.guide.groupIntro')}</Typography>
        <StyledStepList>
          {groupStepKeys.map(key => (
            <li key={key}>
              <Typography type={'body_medium'}>{t(key)}</Typography>
            </li>
          ))}
        </StyledStepList>
        <Typography type={'body_medium'}>{t('preset.guide.groupFromPreset')}</Typography>
        <Alert severity={'info'} text={t('preset.guide.groupLevelRule')} />
      </Column>
      <Column gap={responsive.spacing.small}>
        <Typography type={'heading_xsmall'}>{t('preset.guide.goToTitle')}</Typography>
        <Typography type={'body_medium'}>{t('preset.guide.goToPreset')}</Typography>
        <Typography type={'body_medium'}>{t('preset.guide.goToGroup')}</Typography>
        <Typography type={'body_medium'}>{t('preset.guide.goToMaintenance')}</Typography>
      </Column>
    </StyledGuide>
  );
};

const presetStepKeys = [
  'preset.guide.presetStepMove',
  'preset.guide.presetStepOpen',
  'preset.guide.presetStepName',
  'preset.guide.presetStepPosition',
  'preset.guide.presetStepGroups',
  'preset.guide.presetStepSave',
] as const;

const groupStepKeys = [
  'preset.guide.groupStepOpen',
  'preset.guide.groupStepPresets',
  'preset.guide.groupStepSave',
] as const;
